(()=>{
  const bindings=new WeakMap();
  function bindFooter(){
    const small=window.matchMedia('(max-width:749px)');
    document.querySelectorAll('[data-sbf-group]').forEach(group=>{
      if(group.dataset.footerBound)return;
      group.dataset.footerBound='true';
      group.open=!small.matches;
      small.addEventListener('change',event=>{if(group.isConnected)group.open=!event.matches;});
    });
  }
  function bindLooks(){
    bindFooter();
    document.querySelectorAll('.sucasa-boutique-homepage').forEach(root=>{
      if(root.dataset.looksBound)return;
      root.dataset.looksBound='true';
      root.querySelectorAll('[data-sbh-image]').forEach(button=>button.addEventListener('click',()=>{
        const image=root.querySelector('[data-sbh-look]');
        if(!image)return;
        image.src=button.dataset.sbhImage;
        image.alt=button.getAttribute('aria-label')||image.alt;
        root.querySelectorAll('[data-sbh-image]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
        const status=root.querySelector('[data-sbh-look-status]');
        if(status)status.textContent=button.getAttribute('aria-label')||'';
      }));
    });
  }
  function bindHeader(){
    bindLooks();
    const header=document.getElementById('header-component');
    if(!header||bindings.has(header))return;
    const section=header.closest('.header-section');
    let frame=0;
    const render=()=>{
      frame=0;
      if(!header.isConnected){cleanup();return;}
      const progress=Math.max(0,Math.min(1,window.scrollY/160));
      header.style.setProperty('--header-compression',String(progress));
    };
    const queue=()=>{if(!frame)frame=requestAnimationFrame(render);};
    const measure=()=>{
      const previous=header.style.getPropertyValue('--header-compression');
      header.style.setProperty('--header-compression','0');
      const natural=header.offsetHeight;
      if(section)section.style.setProperty('--sucasa-header-natural-height',natural+'px');
      header.style.setProperty('--header-compression',previous||'0');
      queue();
    };
    const cleanup=()=>{
      document.removeEventListener('scroll',queue);
      window.removeEventListener('resize',measure);
      if(frame)cancelAnimationFrame(frame);
      bindings.delete(header);
    };
    bindings.set(header,cleanup);
    measure();
    document.addEventListener('scroll',queue,{passive:true});
    window.addEventListener('resize',measure,{passive:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bindHeader,{once:true});else bindHeader();
  document.addEventListener('shopify:section:load',bindHeader);
  document.addEventListener('shopify:section:unload',event=>{
    const header=event.target.querySelector?.('#header-component');
    if(header)bindings.get(header)?.();
  });
})();
